import { defineComponent } from 'vue';
import UTCTimeIndicator from '@/presentation/components/shared/utc-time-indicator/utc-time-indicator.vue';
import TopHeaderCode from '@/presentation/components/shared/top-header/top-header.code';

export default defineComponent({
	components: {
		UTCTimeIndicator
	},
	setup: () => {
		const code = new TopHeaderCode();

		return {
			logOutUrl: code.logOutUrl,
			homePageUrl: code.homePageUrl
		};
	}
});
